import DefaultAxios from '../../service/default'
import { InputBoX } from './Default'
import globalData from '../globalData'

// 预算测试类
class BudgetProfitTest{
  constructor(rate = [], obj = {}){
    // 汇率
    this.rate = []
    this.rateTime = ''
    if(rate.length){
      for(let i = 0; i < globalData.countryAbbreviationInvariant.length; i ++){
        let obj = rate.find(e => e.country == globalData.countryAbbreviationInvariant[i])
        this.rate.push(obj.rate)
      }
    }else{
      this.rate = [7.1674, 6.3, 6.3, 6.3, 6.3, 6.3, 6.3, 0.0415, 6.3, 6.3]
    }
    // 英美制单位
    this._unitIndex = obj.lengthType
      ? obj.lengthType
      : 0
    // 当地配送费
    this.localDeliveryFee = 0
    // 月仓储费
    this.monthlyStorageFee = 0
    // 合仓设置费
    this.warehouseConsolidationSettingFee = 0
    // 增值税
    this.importVAT = 0
    // 卖家账户月费
    this.sellerAccountMonthlyFee = 0
    // 忽略增值税对应的国家站点
    this.ignoreValueAddedTaxArray = [7, 8]
    // 计算类型
    this.calType = 1
    /* 站点及卖家账户信息 */
    // 国家站点
    this._countrySite = obj.countrySite
      ? obj.countrySite
      : 0
    // 卖家账户类型
    this.sellerType = obj.sellerType
      ? obj.sellerType
      : null
    // 合仓设置
    this._warehouseConfiguration = obj.warehouseConfiguration
      ? obj.warehouseConfiguration
      : null
    // 独立网络等运营费用
    this.otherFee = obj.otherFee
      ? obj.otherFee
      : null
    // 卖家帐户月均财务费
    this.taxExpense = obj.taxExpense
      ? obj.taxExpense
      : null
    // 店铺管理人力成本
    this.laborCostForStoreManagement = obj.laborCostForStoreManagement
      ? obj.laborCostForStoreManagement
      : null
    /* 单个商品包装数据 */
    // 长
    this._long = obj.long
      ? obj.long
      : null
    // 宽
    this._width = obj.width
      ? obj.width
      : null
    // 高
    this._height = obj.height
      ? obj.height
      : null
    // 重量
    this._weight = obj.weight
      ? obj.weight
      : null
    // 商品分类
    this._sort = obj.sort
      ? obj.sort
      : null
    // 计价单位
    this.unit = obj.unit
      ? obj.unit
      : null
    /* 商品采购及物流成本 */
    // 是否出口退税
    this._xxts = obj.xxts
      ? obj.xxts
      : null
    // 清关及缴税状况
    this.sqbs = obj.sqbs
      ? obj.sqbs
      : null
    // 采购单价
    this.stockPrice = obj.stockPrice
      ? obj.stockPrice
      : null
    // 采购数量
    this.stockNum = obj.stockNum
      ? obj.stockNum
      : null
    // 国内段总运费
    this.domesticFreight = obj.domesticFreight
      ? obj.domesticFreight
      : null
    // 国际段总运费
    this.internationFreight = obj.internationFreight
      ? obj.internationFreight
      : null
    // 海关申报单价
    this.saleTax = obj.saleTax
      ? obj.saleTax
      : null
    // 商品入口关税率
    this.sqrkgsl = obj.sqrkgsl
      ? obj.sqrkgsl
      : null
    // 货物入口税费
    this.importTariff = obj.importTariff
      ? obj.importTariff
      : null
    // 资金运营年息率
    this.operatingAnnualInterestRate = obj.operatingAnnualInterestRate
      ? obj.operatingAnnualInterestRate
      : null
    /* 商品当月运营费用 */
    // 当月站内广告费
    this.advertisingFee = obj.advertisingFee
      ? obj.advertisingFee
      : null
    // 当月站内Deal费用
    this.dealFee = obj.dealFee
      ? obj.dealFee
      : null
    // 当月站内Coupon费用
    this.couponFee = obj.couponFee
      ? obj.couponFee
      : null
    // 当月站外测评费
    this.billingFee = obj.billingFee
      ? obj.billingFee
      : null
    // 当月站外引流费
    this.drainageFee = obj.drainageFee
      ? obj.drainageFee
      : null
    // 商品销售提成率
    this.salesCommission = obj.salesCommission
      ? obj.salesCommission
      : null
    // 运营管理提成率
    this.operationCommission = obj.operationCommission
      ? obj.operationCommission
      : null
    // 平台销售佣金率
    this.commission = obj.commission
      ? obj.commission
      : null
    // 收汇损失率
    this.recoveryLossRate = obj.recoveryLossRate
      ? obj.recoveryLossRate
      : null
    /* 商品售价,销量,退货量,仓储,汇损 */
    // 商品售价
    this.sellingPrice = obj.sellingPrice
      ? obj.sellingPrice
      : null
    // 当月显示销量
    this.showSales = obj.showSales
      ? obj.showSales
      : null
    // 当月坏品退货数
    this.disposalNum = obj.disposalNum
      ? obj.disposalNum
      : null
    // 当月非坏品退货数
    this.returnNum = obj.returnNum
      ? obj.returnNum
      : null
    // 当月弃置移除数量
    this.dyqzycsl = obj.dyqzycsl
      ? obj.dyqzycsl
      : null
    // 商品当前库存量
    this.positionDay = obj.positionDay
      ? obj.positionDay
      : null
    // 当月赔偿回款
    this.dybpcsl = obj.dybpcsl
      ? obj.dybpcsl
      : null
  }
  static LOGISTICSVERITYDATA(){
    let obj = {
      'sort' : 'logisticsSort',
      'countrySite' : 'receivingAddress',
      'xxts' : 'logisticsIsDeclare',
      'sqbs' : 'sqbs',
      'stockPrice' : 'stockPrice',
      'stockNum' : 'stockNum',
    }
    return obj
  }
  /**根据自身类导入数据 */
  importData(obj = {}){
    let keys = Object.keys(obj)
    keys.map(key => {
      this[key] = obj[key]
    })
  }
  get unitIndex(){ return this._unitIndex }
  get countrySite(){ return this._countrySite }
  get warehouseConfiguration(){ return this._warehouseConfiguration }
  get long(){ return this._long }
  get width(){ return this._width }
  get height(){ return this._height }
  get weight(){ return this._weight }
  get sort(){ return this._sort }
  get xxts(){ return this._xxts }
  get unitName(){ return globalData.unitInputOptions[this.unit] }
  get countrySiteName(){ return globalData.countrySiteInputOptions[this.countrySite] }
  set unitIndex(newValue){
    if(newValue){
      this._long = Math.round(this.long / 2.54 * 100) / 100
      this._width = Math.round(this.width / 2.54 * 100) / 100
      this._height = Math.round(this.height / 2.54 * 100) / 100
      this._weight = Math.round(this.weight * 2.2 * 100) / 100
    }else{
      this._long = Math.round(this.long * 2.54 * 100) / 100
      this._width = Math.round(this.width * 2.54 * 100) / 100
      this._height = Math.round(this.height * 2.54 * 100) / 100
      this._weight = Math.round(this.weight / 2.2 * 100) / 100
    }
    this._unitIndex = newValue
    this.amazonLogisticsFee()
  }
  set countrySite(newValue){
    // 根据汇率对应修改售价
    let price = this.sellingPrice * this.rate[this._countrySite] / this.rate[newValue]
    this.sellingPrice = globalData.keepDecimalPoint(price, 2)
    price = this.advertisingFee * this.rate[this._countrySite] / this.rate[newValue]
    this.advertisingFee = globalData.keepDecimalPoint(price, 0)
    price = this.dybpcsl * this.rate[this._countrySite] / this.rate[newValue]
    this.dybpcsl = globalData.keepDecimalPoint(price, 0)
    this._countrySite = newValue == null ? undefined : Number(newValue)
    this.amazonLogisticsFee()
    // 获取增值税
    if(newValue || newValue === 0){
      this.obtainImportVat(newValue)
    }
    // if(newValue == 0 || newValue == 2){
    //   this.unitIndex = 1
    // }else{
    //   this.unitIndex = 0
    // }
  }
  set warehouseConfiguration(newValue){
    this._warehouseConfiguration = newValue
    this.amazonLogisticsFee()
  }
  set long(newValue){
    this._long = newValue
    this.amazonLogisticsFee()
  }
  set width(newValue){
    this._width = newValue
    this.amazonLogisticsFee()
  }
  set height(newValue){
    this._height = newValue
    this.amazonLogisticsFee()
  }
  set weight(newValue){
    this._weight = newValue
    this.amazonLogisticsFee()
  }
  set sort(newValue){
    this._sort = newValue
    this.amazonLogisticsFee()
  }
  set xxts(newValue){
    this.sqbs = newValue == 0 ? 1 : 0
    this._xxts = newValue == null ? undefined : Number(newValue)
  }
  // 亚马逊费用请求体
  get getAmazonLogisticsFeeBody(){
    let obj = {
      "length" : this.long,
      "width" : this.width,
      "height" : this.height,
      "lengthType" : this.unitIndex,
      "weight" : this.weight,
      "weightType" : this.unitIndex,
      "productType" : this.sort,
      "countrySite" : this.countrySite,
      "mergeConfiguration" : this.warehouseConfiguration,
    }
    return obj
  }
  // 设置试用数据
  importTrialData(){
    this.calType = 1
    this.countrySite = 0
    this.sellerType = 0
    this.warehouseConfiguration = 0
    this.otherFee = '30.0'
    this.taxExpense = '0.0'
    this.laborCostForStoreManagement = '0.0'
    this.long = '32.5'
    this.width = '13.5'
    this.height = '10.0'
    this.weight = '1.00'
    this.sort = 0
    this.unit = 0
    this.xxts = 0
    this.stockPrice = '88.0'
    this.stockNum = 300
    this.domesticFreight = '300'
    this.internationFreight = '3000'
    this.saleTax = '88.0'
    this.sqrkgsl = '5.0'
    this.importTariff = 0
    this.operatingAnnualInterestRate = '5.0'
    this.advertisingFee = '100'
    this.dealFee = '0.0'
    this.couponFee = '0.0'
    this.billingFee = '0.0'
    this.drainageFee = '0.0'
    this.salesCommission = '1.0'
    this.operationCommission = '0.5'
    this.commission = '15.0'
    this.recoveryLossRate = '0.25'
    this.sellingPrice = '39.50'
    this.showSales = 100
    this.disposalNum = 2
    this.returnNum = 1
    this.dyqzycsl = 1
    this.positionDay = 200
    this.dybpcsl = '0'
  }
  // 清空数据
  clearData(){
    this.countrySite = null
    this.sellerType = null
    this.warehouseConfiguration = null
    this.otherFee = null
    this.taxExpense = null
    this.operatingAnnualInterestRate = null
    this.laborCostForStoreManagement = null
    this.long = null
    this.width = null
    this.height = null
    this.weight = null
    this.sort = null
    this.unit = null
    this.xxts = null
    this.sqbs = null
    this.stockPrice = null
    this.stockNum = null
    this.domesticFreight = null
    this.internationFreight = null
    this.saleTax = null
    this.sqrkgsl = null
    this.importTariff = null
    this.advertisingFee = null
    this.dealFee = null
    this.couponFee = null
    this.billingFee = null
    this.drainageFee = null
    this.salesCommission = null
    this.operationCommission = null
    this.commission = null
    this.recoveryLossRate = null
    this.sellingPrice = null
    this.showSales = null
    this.disposalNum = null
    this.returnNum = null
    this.dyqzycsl = null
    this.positionDay = null
    this.dybpcsl = null
  }
  // 获取亚马逊费用
  amazonLogisticsFee(){
    let noEmptyAndZeroArray = ['length', 'width', 'height', 'weight']
    let noEmptyArray = ['lengthType', 'weightType', 'productType', 'countrySite', 'mergeConfiguration']
    let obj = this.getAmazonLogisticsFeeBody
    // 判断是否可以发送获取亚马逊费用的请求
    for(let key in obj){
      if(noEmptyAndZeroArray.includes(key)){
        if(!obj[key]) return
      }
      if(noEmptyArray.includes(key)){
        if(!obj[key] && obj[key] !== 0) return
      }
    }
    DefaultAxios.getAmazonLogisticsFee(obj).then(res => {
      this.localDeliveryFee = res.data.info.amazonLogisticsFeeBase + res.data.info.amazonFuelSurcharge
      this.monthlyStorageFee = res.data.info.warehouseFeeMonthly.slice(1)
      this.warehouseConsolidationSettingFee = res.data.info.amazonMergeFee
    })
  }
  // 获取增值税
  obtainImportVat(site){
    DefaultAxios.getImportVat({"countrySite": site}).then(res => {
      if(res.data.code == 1){
        this.importVAT = res.data.info.importVatRate
        this.sellerAccountMonthlyFee = res.data.info.professionalSeller
      }else{
        this.importVAT = 0
        this.sellerAccountMonthlyFee = 39.99
      }
      
    }).catch(() => {
      this.importVAT = 0
      this.sellerAccountMonthlyFee = 39.99
    })
  }
  // 设置汇率
  setRate(object){
    if(!object.rates) return;
    this.rate.splice(0)
    this.rateTime = object.refreshTime
    this.rateTime = new Date().Format('yyyy-MM-dd') + ' 00:00'
    let arr = object.rates
    for(let i = 0; i < globalData.countryAbbreviationInvariant.length; i ++){
      let obj = arr.find(e => e.country == globalData.countryAbbreviationInvariant[i])
      this.rate.push(obj && obj.rate)
    }
  }
  /**采购单价 */
  get getPurchaseUnitPrice(){
    return this.stockPrice ? this.stockPrice : 0
  }
  /**国内段单位运费 */
  get getDomesticUnitFreight(){
    if(!this.domesticFreight || !this.stockNum){
      return 0
    }
    let num = Number(this.domesticFreight) / Number(this.stockNum)
    return num
  }
  /**国际段单位运费 */
  get getInternationalUnitFreight(){
    if(!this.internationFreight || !this.stockNum){
      return 0
    }
    let num = Number(this.internationFreight) / Number(this.stockNum)
    return num
  }
  /**平台销售佣金 */
  get getAmazonSalesCommission(){
    if(!this.sellingPrice){
      return 0
    }
    let exchangeRate = Number(this.rate[this.countrySite])
    let num = exchangeRate * Number(this.sellingPrice) * Number(this.commission) / 100
    return num
  }
  /**当地配送费 */
  get getLocalDeliveryFee(){
    let num = Number(this.localDeliveryFee) * Number(this.rate[0])
    return num
  }
  /**商品入口关税 */
  get getImportTariffsOnGoods(){
    let num = Number(this.saleTax) * Number(this.stockNum) * Number(this.sqrkgsl)
    / Number(this.getCalculateBasedOnActualSalesVolume) / 100
    return num
  }
  /**商品入口增值税 */
  get getValueAddedTaxOnImportedGoods(){
    if(this.ignoreValueAddedTaxArray.includes(this.countrySite)){
      return 0
    }
    let num = Number(this.getImportTariffsOnGoods) + Number(this.saleTax)
      + Number(this.getInternationalUnitFreight)
    num = num * Number(this.importVAT)
    return num
  }
  /**商品销售增值税 */
  get getValueAddedTaxOnSalesOfGoods(){
    let num = Number(this.sellingPrice) * Number(this.rate[this.countrySite]) * Number(this.stockNum)
      * Number(this.importVAT) / (1 + Number(this.importVAT)) / Number(this.stockNum)
    return num
  }
  /**商品销售VAT */
  get getSalesVATOnGoods(){
    if(this.ignoreValueAddedTaxArray.includes(this.countrySite)){
      return 0
    }
    let num = (Number(this.stockPrice) * Number(this.stockNum) + Number(this.domesticFreight)
      + Number(this.internationFreight) + Number(this.getImportTariffsOnGoods)
      * Number(this.getCalculateBasedOnActualSalesVolume)) * Number(this.importVAT)
      / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**地方消费税 */
  get getLocalConsumptionTax(){
    let num = Number(this.sellingPrice) * Number(this.rate[this.countrySite])
      / (1 + 0.078) * 0.078
    return num
  }
  /**退税 */
  get getTaxRefund(){
    if(this.sqbs == 0){
      return 0
    }
    let num = Number(this.getSalesVATOnGoods) - Number(this.getValueAddedTaxOnSalesOfGoods)
    return num
  }
  /**清关杂费(ADV) */
  get getCustomsClearanceMiscellaneousFees(){
    let num = 0
    return num
  }
  /**单位商品入口综合税 */
  get getComprehensiveTaxesAndFeesOfTheImportingCountry(){
    let arr1 = globalData.europeIndexArray
    let arr2 = globalData.europeAndAmericaIndexArray
    let arr3 = globalData.aisaIndexArray
    let bool
    let isExistGetValueAddedTaxOnSalesOfGoods = false
    let resultArr = []
    let num  = 0
    let tariffNum = 0
    if(arr1.includes(this.countrySite)){
      resultArr = ProfitInputNewModule.NEWTAXDATAEUROPE()
    }else if(arr2.includes(this.countrySite)){
      resultArr = ProfitInputNewModule.NEWTAXDATAEUROPEANDAMERICE()
    }else if(arr3.includes(this.countrySite)){
      resultArr = ProfitInputNewModule.NEWTAXDATAAISA()
    }
    // 删掉最后一个元素
    resultArr.input.pop()
    resultArr.input.map(e => {
      bool = e.data == 'getSalesVATOnGoods'
      || (e.data == 'getTaxRefund' && this.sqbs == 1)
      || (e.data == 'getImportTariffsOnGoods' && this.sqbs == 0)
      if(e.data == 'getValueAddedTaxOnSalesOfGoods') isExistGetValueAddedTaxOnSalesOfGoods = true
      if(!bool){
        num = num + this[e.data]
      }
    })
    if(isExistGetValueAddedTaxOnSalesOfGoods){
      tariffNum = num - this.getValueAddedTaxOnSalesOfGoods
      tariffNum = tariffNum * Number(this.getCalculateBasedOnActualSalesVolume)
      tariffNum += this.getValueAddedTaxOnSalesOfGoods * this.stockNum
    }else{
      tariffNum = num * Number(this.getCalculateBasedOnActualSalesVolume)
    }
    this.importTariff = (Math.round(tariffNum * 10) / 10).toFixed(1)
    return num
  }
  /**仓储费用分摊 */
  get getStorageCostAllocation(){
    let num = Number(this.long) * Number(this.width) * Number(this.height)
      * Number(this.monthlyStorageFee) * Number(this.rate[this.countrySite])
      / 30 / 1000000 / Number(this.getCalculateBasedOnActualSalesVolume)
    num = num * (15 * Number(this.showSales) + 30 * Number(this.positionDay))
    if(this.unitIndex){
      num = num * 2.54 * 2.54 * 2.54
    }
    return num
  }
  /**合仓设置费 */
  get getWarehouseConsolidationSettingFee(){
    let num = Number(this.warehouseConsolidationSettingFee) * Number(this.rate[0])
    return num
  }
  /**当月站内广告费用分摊 */
  get getSharingOfAdvertisingExpensesWithinTheSiteForTheCurrentMonth(){
    let num = Number(this.advertisingFee) * Number(this.rate[this.countrySite]) / Number(this.getDisplaySalesVolumeForCalculationPurposes)
    return num
  }
  /**当月站内Deal费用分摊 */
  get getSharingOfOnSiteDealCostsForTheCurrentMonth(){
    let num = Number(this.dealFee) * Number(this.rate[this.countrySite]) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**当月站内Coupon费用分摊 */
  get getSharingOfOnSiteCouponExpensesForTheCurrentMonth(){
    let num = Number(this.couponFee) * Number(this.rate[this.countrySite]) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**当月站外测评费用分摊 */
  get getSharingOfOffSiteEvaluationCostsForTheCurrentMonth(){
    let num = Number(this.billingFee) / Number(this.getDisplaySalesVolumeForCalculationPurposes)
    return num
  }
  /**当月站外引流费用分摊 */
  get getSharingOfExternalDrainageCostsForTheCurrentMonth(){
    let num = Number(this.drainageFee) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**专业销售卖家帐户月费分摊 / 个人销售计划月费分摊 */
  /* HACK继承该类的时候需要根据计算类型把 计算用实际销量 换成 店铺在售数量 */
  get getSellerMonthlyFeeSharing(){
    if((!this.sellerType && this.sellerType != 0)){
      return 0
    }
    if(this.sellerType == 1){
      return 0
      // return 0.99 * Number(this.rate[0])
    }
    let num = Number(globalData.warehouseFee[this.countrySite]) * Number(this.rate[this.countrySite])
      / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**独立网络等运营月费分摊 */
  /* HACK继承该类的时候需要根据计算类型把 计算用实际销量 换成 店铺在售数量 */
  get getAllocationOfMonthlyOperatingExpensesForIndependentNetworksAndOtherServices(){
    let num = Number(this.otherFee) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /** 卖家帐户月均财务费分摊 */
  /* HACK 继承该类的时候需要根据计算类型把 计算用实际销量 换成 店铺在售数量 */
  get getMonthlyAverageDinancialExpenseAllocationForSellerAccounts(){
    let num = Number(this.taxExpense) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }

  /**
   * 坏品退货损耗分摊
   *
   * (采购单价 + 国内运费 + 国际运费 + 平台销售佣金 + 当地配送费
   * + 入口关税 + 资金运营利息) * 当月坏品退货数 / 计算用实际销量
   */
  get getLossAllocationForReturnsOfDefectiveProducts(){
    let num = Number(this.getPurchaseUnitPrice) + Number(this.getDomesticUnitFreight)
      + Number(this.getInternationalUnitFreight) + Number(this.getAmazonSalesCommission)
      + Number(this.getLocalDeliveryFee) + Number(this.getImportTariffsOnGoods)
      + Number(this.getFundOperationInterest)
    num = num * Number(this.disposalNum) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**非坏品退货损耗分摊 */
  get getNonDefectiveProductReturnLossAllocation(){
    let num = 0.2 * 0.15 * Number(this.sellingPrice) * Number(this.rate[this.countrySite])
      * Number(this.returnNum) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**
   * 收汇损失
   *
   * (产品售价 - 平台销售佣金 - 当地配送费 - 当月站内广告费用分摊
   * - 坏品退货损耗分摊 - 非坏品退货损耗分摊 - 仓储费用分摊 - 帐户月费分摊
   * - 合仓设置费) * 收汇损失率 / 100
   */
  get getCollectionLoss(){
    let num = Number(this.getProductSellingPrice) - Number(this.getAmazonSalesCommission)
      - Number(this.getLocalDeliveryFee) - Number(this.getSharingOfAdvertisingExpensesWithinTheSiteForTheCurrentMonth)
      - Number(this.getLossAllocationForReturnsOfDefectiveProducts) - Number(this.getNonDefectiveProductReturnLossAllocation)
      - Number(this.getStorageCostAllocation) - Number(this.getSellerMonthlyFeeSharing)
      - Number(this.getWarehouseConsolidationSettingFee)
    num = num * Number(this.recoveryLossRate) / 100
    return num
  }
  /**
   * 资金运营利息
   *
   * 单位商品资金运营利息 = 单位商品出资成本
   * * （生产数量 + 运输数量 + 当月商品显示销量 + 当月商品库存数量）
   * * 资金运营年息率 / 12 / 计算用实际销量
   */
  get getFundOperationInterest(){
    let num = Number(this.showSales) + Number(this.positionDay) + Number(this.stockNum) + Number(this.stockNum)
    num = num * Number(this.getCostOfCommodityInvestment) * Number(this.operatingAnnualInterestRate)
      / 12 / 100 / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**商品销售提成分摊 */
  get getSharingOfCommissionOnProductSales(){
    let num = Number(this.sellingPrice) * Number(this.rate[this.countrySite]) * Number(this.salesCommission) / 100
    return num
  }
  /**运营管理提成分摊 */
  get getOperationManagementCommissionSharing(){
    let num = Number(this.sellingPrice) * Number(this.rate[this.countrySite]) * Number(this.operationCommission) / 100
    return num
  }
  /**赔偿回款分摊 */
  get getCompensationCollectionSharing(){
    let num = Number(this.dybpcsl) * Number(this.rate[this.countrySite])
      / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**店铺管理人力成本分摊 */
  get getAllocationOfLaborCostsInStoreManagement(){
    let num = Number(this.laborCostForStoreManagement) / Number(this.getCalculateBasedOnActualSalesVolume)
    return num
  }
  /**
   * 成本汇总
   * (采购单价 + 国内段单位运费 + 国际段单位运费 + 平台销售佣金 + 当地配送费 + 单位商品入口综合税
   * + 仓储费用分摊 + 合仓设置费 + 当月站内广告费用分摊 + 当月站外测评费用分摊 + 当月站外引流费用分摊 + 独立网络等运营月费分摊 + 帐户月费分摊
   * + 卖家帐户月均财务费分摊 + 坏品退货损耗分摊 + 非坏品退货损耗分摊 + 收汇损失 + 资金运营利息+ 商品销售提成分摊 + 运营管理提成分摊)
   */
  get getCostSummary(){
    let num = Number(this.getPurchaseUnitPrice)
      + Number(this.getDomesticUnitFreight)
      + Number(this.getInternationalUnitFreight)
      + Number(this.getAmazonSalesCommission)
      + Number(this.getLocalDeliveryFee)
      + Number(this.getComprehensiveTaxesAndFeesOfTheImportingCountry)
      + Number(this.getStorageCostAllocation)
      + Number(this.getWarehouseConsolidationSettingFee)
      + Number(this.getSharingOfAdvertisingExpensesWithinTheSiteForTheCurrentMonth)
      + Number(this.getSharingOfOffSiteEvaluationCostsForTheCurrentMonth)
      + Number(this.getSharingOfExternalDrainageCostsForTheCurrentMonth)
      + Number(this.getSellerMonthlyFeeSharing)
      + Number(this.getAllocationOfMonthlyOperatingExpensesForIndependentNetworksAndOtherServices)
      + Number(this.getMonthlyAverageDinancialExpenseAllocationForSellerAccounts)
      + Number(this.getLossAllocationForReturnsOfDefectiveProducts)
      + Number(this.getNonDefectiveProductReturnLossAllocation)
      + Number(this.getCollectionLoss)
      + Number(this.getFundOperationInterest)
      + Number(this.getAllocationOfLaborCostsInStoreManagement)
      + Number(this.getSharingOfCommissionOnProductSales)
      + Number(this.getOperationManagementCommissionSharing)
    return num
  }
  /**商品售价 */
  get getProductSellingPrice(){
    let num = Number(this.sellingPrice) * Number(this.rate[this.countrySite])
    return num
  }
  /**商品净利润 */
  get getNetProfitOfGoods(){
    let num = Number(this.getProductSellingPrice) - Number(this.getCostSummary)
    return num
  }
  /**
   * 商品出资成本
   *
   * 入口关税  + 采购单价 + 国内单位运费 + 国际单位运费 + 当月站外测评费用分摊
   * + 站外月引流费用分摊 + 独立网络等运营月费分摊 + 卖家帐户月费分摊
   */
  get getCostOfCommodityInvestment(){
    let num = Number(this.getPurchaseUnitPrice) + Number(this.getDomesticUnitFreight)
      + Number(this.getInternationalUnitFreight) + Number(this.getImportTariffsOnGoods)
      + Number(this.getSharingOfOffSiteEvaluationCostsForTheCurrentMonth)
      + Number(this.getSharingOfExternalDrainageCostsForTheCurrentMonth)
      + Number(this.getSellerMonthlyFeeSharing)
      + Number(this.getAllocationOfMonthlyOperatingExpensesForIndependentNetworksAndOtherServices)
    return num
  }
  /**
   * 商品收汇
   *
   * (商品售价 - 平台销售佣金 - 当地配送费 - 当月站内广告费用分摊 - 坏品退货损耗分摊
   * - 非坏品退货损耗分摊 - 仓储费用分摊 - 合仓设置费 - 帐户月费分摊 - 收汇损失)
   */
  get getCommodityCollection(){
    let num = Number(this.getProductSellingPrice) - Number(this.getAmazonSalesCommission)
      - Number(this.getLocalDeliveryFee) - Number(this.getSharingOfAdvertisingExpensesWithinTheSiteForTheCurrentMonth)
      - Number(this.getLossAllocationForReturnsOfDefectiveProducts) - Number(this.getNonDefectiveProductReturnLossAllocation)
      - Number(this.getStorageCostAllocation) - Number(this.getWarehouseConsolidationSettingFee)
      - Number(this.getSellerMonthlyFeeSharing) - Number(this.getCollectionLoss)
    return num
  }
  /**当月实际销量 */
  get getActualSalesVolumeForTheMonth(){
    let num = Number(this.showSales) - Number(this.returnNum) - Number(this.disposalNum)
    return num
  }
  /**计算用实际销量 */
  get getCalculateBasedOnActualSalesVolume(){
    return Number(this.getActualSalesVolumeForTheMonth) > 1
      ? Number(this.getActualSalesVolumeForTheMonth)
      : 1
  }
  /**计算用显示销量 */
  get getDisplaySalesVolumeForCalculationPurposes(){
    return Number(this.showSales) > 1
      ? Number(this.showSales)
      : 1
  }
  /**当月总销售额 */
  get getTotalSalesForTheMonth(){
    let num = Number(this.getProductSellingPrice) * Number(this.showSales)
    return num
  }
  /**当月总收汇 */
  get getTotalForeignExchangeReceiptsForTheMonth(){
    let num = Number(this.getCommodityCollection) * Number(this.getActualSalesVolumeForTheMonth)
    return num
  }
  /**当月总销售利润 */
  get getTotalSalesProfitForTheMonth(){
    if(!this.getActualSalesVolumeForTheMonth){
      return 0
    }
    let num = Number(this.getCalculateBasedOnActualSalesVolume) * Number(this.getNetProfitOfGoods)
    return num
  }
  /**当月销售利润率 */
  get getMonthlySalesProfitMargin(){
    if(!this.getActualSalesVolumeForTheMonth || !this.getProductSellingPrice){
      return 0
    }
    let num = Number(this.getNetProfitOfGoods) / Number(this.getProductSellingPrice)
    return num * 100
  }
  /**当月成本利润率 */
  get getMonthlyCostProfitMargin(){
    if(!this.getActualSalesVolumeForTheMonth || !this.getCostOfCommodityInvestment){
      return 0
    }
    let num = Number(this.getNetProfitOfGoods) / Number(this.getCostOfCommodityInvestment)
    return num * 100
  }
  // 需要输入的数据
  needArray(){
    let arr = [
      'countrySite', 'sellerType', 'warehouseConfiguration', 'otherFee', 'taxExpense', 'operatingAnnualInterestRate',
      'long', 'width', 'height', 'weight', 'sort', 'unit',
      'xxts', 'sqbs', 'stockPrice', 'stockNum', 'domesticFreight', 'internationFreight', 'saleTax', 'sqrkgsl',
      'advertisingFee', 'billingFee', 'drainageFee', 'salesCommission', 'operationCommission', 'commission', 'recoveryLossRate',
      'sellingPrice', 'showSales', 'disposalNum', 'dyqzycsl', 'positionDay', 'dybpcsl',
    ]
    if(this.sqbs != 0){
      if(!arr.indexOf('saleTax')){
        arr.push('saleTax')
        arr.push('sqrkgsl')
      }
    }else{
      arr = arr.filter(a => a !== 'sqrkgsl' && a !== 'saleTax')
    }
    return arr
  }
}

// 利润输入框类
class ProfitInputBox extends InputBoX{
  constructor(type, name, data, obj = {icon: 0, unit: 0, decimal: 0, pla: '', html: false}){
    super(type, name, data, obj)
    if(data === 'importTariff'){
      this.html = globalData['importTariffInputHtml0']
    }
    let enumType = [
      INPUTENUM.NONE,
      INPUTENUM.DEFAULT,
      INPUTENUM.NATIONAL,
      INPUTENUM.LENGTH,
      INPUTENUM.WEIGHT,
      INPUTENUM.UNIT,
      INPUTENUM.PERUNIT
    ]
    // 单位
    this.unit = enumType[obj.unit ? obj.unit : 0]
    // 货币符号
    this.icon = enumType[obj.icon ? obj.icon : 0]
  }
}

// 利润输入框模块
/**
 * title : String
 * input : ProfitInputBox[]
 */
class ProfitInputBoxModule{
  constructor(title, input = [], flex = 1, width = 1) {
    this.flex = flex
    this.width = width
    this.title = title
    this.input = input
  }
}

// 输入框枚举
class INPUTENUM{
  static NONE = 'none'
  static DEFAULT = 'default'
  static NATIONAL = 'national'
  static LENGTH = 'length'
  static WEIGHT = 'weight'
  static UNIT = 'unit'
  static PERUNIT = 'perUnit'

  // 判断枚举对应的返回数据
  static judgeEnumReturnString =  {
    "length" : globalData.lengthArrayInvariant,
    "weight" : globalData.weightArrayInvariant,
    "unit" : globalData.unitInputOptions,
    "perUnit" : globalData.unitInputOptions.map(s => '/' + s),
    'default' : globalData.nationalCurrencyInvariant.map(() => '¥'),
    'national' : globalData.nationalCurrencyInvariant,
  }
  constructor(){}
}

// 利润输入模块创建类
class ProfitInputNewModule{
  static NEWINPUT(){
    let obj = {
      sellerInfo: new ProfitInputBoxModule('国家站点及卖家账户信息', {
        countrySite: new ProfitInputBox('select', '商品所属国家站点', 'countrySite', { pla: '请选择' }),
        sellerType: new ProfitInputBox('select', '卖家账户类型', 'sellerType', { html: true }),
        warehouseConfiguration: new ProfitInputBox('select', '合仓设置(按国家)', 'warehouseConfiguration', { html: true }),
        otherFee: new ProfitInputBox('number', '独立网络等月费占比', 'otherFee', { icon: 1, decimal: 1, html: true }),
        taxExpense: new ProfitInputBox('number', '帐户月均财务费占比', 'taxExpense', { icon: 1, decimal: 1, html: true }),
        laborCostForStoreManagement: new ProfitInputBox('number', '管理人力成本占比', 'laborCostForStoreManagement', { icon: 1, decimal: 1, html: true }),
      }, 1, 1),
      packData: new ProfitInputBoxModule('商品包装及归类', {
        long: new ProfitInputBox('number', '长', 'long', { unit: 3, decimal: 1 }),
        width: new ProfitInputBox('number', '宽', 'width', { unit: 3, decimal: 1 }),
        height: new ProfitInputBox('number', '高', 'height', { unit: 3, decimal: 1 }),
        weight: new ProfitInputBox('number', '重量', 'weight', { unit: 4, decimal: 2 }),
        unit: new ProfitInputBox('select', '计价单位', 'unit'),
        sort: new ProfitInputBox('select', '商品分类', 'sort'),
      }, 0.8, 2),
      stockCost: new ProfitInputBoxModule('商品采购,出口退税,物流,清关缴税', {
        xxts: new ProfitInputBox('select', '独立报关及退税', 'xxts', { html: true, pla: '请选择' }),
        sqbs: new ProfitInputBox('select', '入口清关及缴税', 'sqbs', { html: true, isDisable: true }),
        stockPrice: new ProfitInputBox('number', '采购单价', 'stockPrice', { icon: 1, unit: 6, decimal: 1, html: true }),
        stockNum: new ProfitInputBox('number', '采购数量', 'stockNum', { unit: 5, html: true }),
        saleTax: new ProfitInputBox('number', '海关申报单价', 'saleTax', { icon: 1, unit: 6, decimal: 1, html: true }),
        sqrkgsl: new ProfitInputBox('number', '商品入口关税率', 'sqrkgsl', { decimal: 1, html: true }),
        domesticFreight: new ProfitInputBox('number', '国内段总运费', 'domesticFreight', { icon: 1, decimal: 0, html: true }),
        internationFreight: new ProfitInputBox('number', '国际段总运费', 'internationFreight', { icon: 1, decimal: 0, html: true }),
        importTariff: new ProfitInputBox('number', '入口国自缴综合税', 'importTariff', { icon: 1, decimal: 1, html: true }),
      }, 1, 3),
      operatingExpenses: new ProfitInputBoxModule('商品当月运营费用', {
        advertisingFee: new ProfitInputBox('number', '当月站内广告费', 'advertisingFee', { icon: 2, decimal: 0, html: true }),
        // dealFee: new ProfitInputBox('number', '当月站内Deal费用', 'dealFee', { icon: 2, html: true }),
        // couponFee: new ProfitInputBox('number', '当月站内Coupon费用', 'couponFee', { icon: 2, html: true }),
        billingFee: new ProfitInputBox('number', '当月站外测评费', 'billingFee', { icon: 1, decimal: 1, html: true }),
        drainageFee: new ProfitInputBox('number', '当月站外引流费', 'drainageFee', { icon: 1, decimal: 1, html: true }),
        salesCommission: new ProfitInputBox('number', '商品销售提成率', 'salesCommission', { decimal: 1, html: true }),
        operationCommission: new ProfitInputBox('number', '运营管理提成率', 'operationCommission', { decimal: 1, html: true }),
        commission: new ProfitInputBox('number', '平台销售佣金率', 'commission', { decimal: 1, html: true }),
        recoveryLossRate: new ProfitInputBox('number', '收汇损失率', 'recoveryLossRate', { decimal: 1, html: true }),
        operatingAnnualInterestRate: new ProfitInputBox('number', '资金运营年息率', 'operatingAnnualInterestRate', { decimal: 1 , html: true })
      }, 1.1, 4),
      productRevenue: new ProfitInputBoxModule('商品售价,销量,退货量,库存量,赔款', {
        sellingPrice: new ProfitInputBox('number', '商品售价', 'sellingPrice', { icon: 2,unit: 6, decimal: 2, html: true }),
        showSales: new ProfitInputBox('number', '当月显示销量', 'showSales', { unit: 5, html: true }),
        disposalNum: new ProfitInputBox('number', '当月坏品退货数', 'disposalNum', { unit: 5, html: true }),
        returnNum: new ProfitInputBox('number', '当月非坏品退货数', 'returnNum', { unit: 5, html: true }),
        dyqzycsl: new ProfitInputBox('number', '当月弃置移除数量', 'dyqzycsl', { unit: 5, html: true }),
        positionDay: new ProfitInputBox('number', '商品当前库存量', 'positionDay', { unit: 5, html: true }),
        dybpcsl: new ProfitInputBox('number', '当月赔偿回款', 'dybpcsl', { icon: 2, decimal: 0, html: true }),
      }, 1.1, 3)
    }
    return obj
  }
  static NEWINPUTBYSTORE(){
    let obj = {
      sellerInfo: new ProfitInputBoxModule('国家站点及卖家账户信息', {
        countrySite: new ProfitInputBox('select', '商品所属国家站点', 'countrySite', { pla: '请选择' }),
        store: new ProfitInputBox('select', '商品所属店铺', 'store'),
        sellerType: new ProfitInputBox('select', '卖家账户类型', 'sellerType', { html: true }),
        warehouseConfiguration: new ProfitInputBox('select', '合仓设置(按国家)', 'warehouseConfiguration', { html: true }),
        otherFee: new ProfitInputBox('number', '独立网络等运营月费', 'otherFee', { icon: 1, decimal: 1, html: true }),
        taxExpense: new ProfitInputBox('number', '卖家帐户月均财务费', 'taxExpense', { icon: 1, decimal: 1, html: true }),
        laborCostForStoreManagement: new ProfitInputBox('number', '店铺管理人力成本', 'laborCostForStoreManagement', { icon: 1, decimal: 1, html: true }),
      }, 1, 1),
      packData: new ProfitInputBoxModule('单个商品包装数据', {
        long: new ProfitInputBox('number', '长', 'long', { unit: 3, decimal: 1 }),
        width: new ProfitInputBox('number', '宽', 'width', { unit: 3, decimal: 1 }),
        height: new ProfitInputBox('number', '高', 'height', { unit: 3, decimal: 1 }),
        weight: new ProfitInputBox('number', '重量', 'weight', { unit: 4, decimal: 2 }),
        sort: new ProfitInputBox('select', '商品分类', 'sort'),
        unit: new ProfitInputBox('select', '计价单位', 'unit'),
      }, 0.8, 2),
      stockCost: new ProfitInputBoxModule('商品采购,出口退税,物流,清关缴税', {
        xxts: new ProfitInputBox('select', '独立报关及退税', 'xxts', { html: true, pla: '请选择' }),
        sqbs: new ProfitInputBox('select', '入口清关及缴税', 'sqbs', { html: true, isDisable: true }),
        stockPrice: new ProfitInputBox('number', '采购单价', 'stockPrice', { icon: 1, unit: 6, decimal: 1, html: true }),
        stockNum: new ProfitInputBox('number', '采购数量', 'stockNum', { unit: 5, html: true }),
        saleTax: new ProfitInputBox('number', '海关申报单价', 'saleTax', { icon: 1, unit: 6, decimal: 1, html: true }),
        sqrkgsl: new ProfitInputBox('number', '商品入口关税率', 'sqrkgsl', { decimal: 1, html: true }),
        domesticFreight: new ProfitInputBox('number', '国内段总运费', 'domesticFreight', { icon: 1, decimal: 0, html: true }),
        internationFreight: new ProfitInputBox('number', '国际段总运费', 'internationFreight', { icon: 1, decimal: 0, html: true }),
        importTariff: new ProfitInputBox('number', '入口国自缴综合税', 'importTariff', { icon: 1, decimal: 1 }),
      }, 1, 3),
      operatingExpenses: new ProfitInputBoxModule('商品当月运营费用', {
        advertisingFee: new ProfitInputBox('number', '当月站内广告费', 'advertisingFee', { icon: 2, decimal: 0, html: true }),
        // dealFee: new ProfitInputBox('number', '当月站内Deal费用', 'dealFee', { icon: 2, html: true }),
        // couponFee: new ProfitInputBox('number', '当月站内Coupon费用', 'couponFee', { icon: 2, html: true }),
        billingFee: new ProfitInputBox('number', '当月站外测评费', 'billingFee', { icon: 1, decimal: 1, html: true }),
        drainageFee: new ProfitInputBox('number', '当月站外引流费', 'drainageFee', { icon: 1, decimal: 1, html: true }),
        salesCommission: new ProfitInputBox('number', '商品销售提成率', 'salesCommission', { decimal: 1, html: true }),
        operationCommission: new ProfitInputBox('number', '运营管理提成率', 'operationCommission', { decimal: 1, html: true }),
        commission: new ProfitInputBox('number', '平台销售佣金率', 'commission', { decimal: 1, html: true }),
        recoveryLossRate: new ProfitInputBox('number', '收汇损失率', 'recoveryLossRate', { decimal: 1, html: true }),
        operatingAnnualInterestRate: new ProfitInputBox('number', '资金运营年息率', 'operatingAnnualInterestRate', { decimal: 1 , html: true })
      }, 1.1, 4),
      productRevenue: new ProfitInputBoxModule('商品售价,销量,退货量,库存量,赔款', {
        sellingPrice: new ProfitInputBox('number', '商品售价', 'sellingPrice', { icon: 2,unit: 6, decimal: 2 }),
        showSales: new ProfitInputBox('number', '当月显示销量', 'showSales', { unit: 5, html: true }),
        disposalNum: new ProfitInputBox('number', '当月坏品退货数', 'disposalNum', { unit: 5, html: true }),
        returnNum: new ProfitInputBox('number', '当月非坏品退货数', 'returnNum', { unit: 5, html: true }),
        dyqzycsl: new ProfitInputBox('number', '当月弃置移除数量', 'dyqzycsl', { unit: 5, html: true }),
        positionDay: new ProfitInputBox('number', '商品当前库存量', 'positionDay', { unit: 5, html: true }),
        dybpcsl: new ProfitInputBox('number', '当月赔偿回款', 'dybpcsl', { icon: 2, decimal: 0, html: true }),
      }, 1.1, 3)
    }
    return obj
  }
  static NEWCAL(){
    let obj = {
      1: new ProfitInputBoxModule('', [
        new ProfitInputBox('cal', '采购单价', 'getPurchaseUnitPrice', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '国内段单位运费', 'getDomesticUnitFreight', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '国际段单位运费', 'getInternationalUnitFreight', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '平台销售佣金', 'getAmazonSalesCommission', { decimal: 2, unit: 6, html: true }),
        new ProfitInputBox('cal', '当地配送费', 'getLocalDeliveryFee', { decimal: 2, unit: 6, html: true }),
        new ProfitInputBox('cal', '入口国自缴综合税分摊', 'getComprehensiveTaxesAndFeesOfTheImportingCountry', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '仓储费用分摊', 'getStorageCostAllocation', { decimal: 2, unit: 6, html: true }),
      ]),
      2: new ProfitInputBoxModule('', [
        
        new ProfitInputBox('cal', '当月站内广告费用分摊', 'getSharingOfAdvertisingExpensesWithinTheSiteForTheCurrentMonth', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '当月站外测评费用分摊', 'getSharingOfOffSiteEvaluationCostsForTheCurrentMonth', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '当月站外引流费用分摊', 'getSharingOfExternalDrainageCostsForTheCurrentMonth', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '坏品退货损耗分摊', 'getLossAllocationForReturnsOfDefectiveProducts', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '非坏品退货损耗分摊', 'getNonDefectiveProductReturnLossAllocation', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '收汇损失', 'getCollectionLoss', { decimal: 2, unit: 6, html: true }),
        new ProfitInputBox('cal', '资金运营利息', 'getFundOperationInterest', { decimal: 2, unit: 6, html: true }),
      ]),
      3: new ProfitInputBoxModule('', [
        new ProfitInputBox('cal', '商品销售提成分摊', 'getSharingOfCommissionOnProductSales', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '运营管理提成分摊', 'getOperationManagementCommissionSharing', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '合仓设置费', 'getWarehouseConsolidationSettingFee', { decimal: 2, unit: 6, html: true }),
        new ProfitInputBox('cal', '卖家帐户月费分摊', 'getSellerMonthlyFeeSharing', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '独立网络等运营月费分摊', 'getAllocationOfMonthlyOperatingExpensesForIndependentNetworksAndOtherServices', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '卖家帐户月均财务费分摊', 'getMonthlyAverageDinancialExpenseAllocationForSellerAccounts', { decimal: 2, unit: 6 }),
        new ProfitInputBox('cal', '店铺管理人力成本分摊', 'getAllocationOfLaborCostsInStoreManagement', { decimal: 2, unit: 6, html: true }),
        
      ])
    }
    return obj
  }
  static NEWPROFIT(){
    let arr = [
      new ProfitInputBox('cal', '商品售价', 'getProductSellingPrice', { decimal: 1, unit: 6 }),
      new ProfitInputBox('cal', '商品利润', 'getNetProfitOfGoods', { decimal: 1, unit: 6 }),
      new ProfitInputBox('cal', '商品出资成本', 'getCostOfCommodityInvestment', { decimal: 1, unit: 6, html: true }),
      new ProfitInputBox('cal', '商品收汇', 'getCommodityCollection', { decimal: 1, unit: 6, html: true }),
      new ProfitInputBox('cal', '当月实际销量', 'getActualSalesVolumeForTheMonth', { unit: 5, html: true }),
      new ProfitInputBox('cal', '当月总销售额', 'getTotalSalesForTheMonth'),
      new ProfitInputBox('cal', '当月总收汇', 'getTotalForeignExchangeReceiptsForTheMonth'),
      new ProfitInputBox('cal', '当月总销售利润', 'getTotalSalesProfitForTheMonth', { decimal: 0 }),
      new ProfitInputBox('cal', '当月销售利润率', 'getMonthlySalesProfitMargin', { decimal: 1, html: true }),
      new ProfitInputBox('cal', '当月成本利润率', 'getMonthlyCostProfitMargin', { decimal: 1, html: true }),
    ]
    return arr
  }
  // 欧洲税务弹窗
  // 2026-11-29 改为税务默认弹窗
  static NEWTAXDATAEUROPE(){
    let obj = new ProfitInputBoxModule('入口国自缴综合税', [
      new ProfitInputBox('tax', '商品入口关税(Import Duty)', 'getImportTariffsOnGoods', { decimal: 1, unit: 6, html:true, pla: '(物流公司自缴)' }),
      new ProfitInputBox('tax', '商品入口销售增值税(Import VAT)', 'getSalesVATOnGoods', { decimal: 1, unit: 6, pla: '(物流公司自缴或申请递延)', html: true }),
      new ProfitInputBox('tax', '清关杂费(ADV)', 'getCustomsClearanceMiscellaneousFees', { decimal: 1, unit: 6, pla: '(物流公司自缴或申请递延)', html: true }),
      new ProfitInputBox('tax', '需缴商品销售增值税(Sales VAT)', 'getValueAddedTaxOnSalesOfGoods', { decimal: 1, unit: 6, pla: '(亚马逊代缴,仅记账即可)' }),
      new ProfitInputBox('tax', '代缴商品销售后退税或补税', 'getTaxRefund', { decimal: 1, unit: 6, html: true, pla: '(最终由亚马逊售后完税代缴)' }),
      new ProfitInputBox('tax', '商品综合税', 'getComprehensiveTaxesAndFeesOfTheImportingCountry', { decimal: 1, unit: 6, pla: '(+数补税,-数为退税,0为不退不补)' }),
    ])
    return obj
  }
  // 欧美税务弹窗
  static NEWTAXDATAEUROPEANDAMERICE(){
    let obj = new ProfitInputBoxModule('商品入口国综合税', [
      new ProfitInputBox('tax', '商品入口关税(Import Duty)', 'getImportTariffsOnGoods', { decimal: 1, unit: 6, html:true, pla: '(自缴)' }),
      new ProfitInputBox('tax', '商品入口综合税', 'getComprehensiveTaxesAndFeesOfTheImportingCountry', { decimal: 1, unit: 6 }),
    ])
    return obj
  }
  // 亚洲税务弹窗
  static NEWTAXDATAAISA(){
    let obj = new ProfitInputBoxModule('商品入口国综合税', [
      new ProfitInputBox('tax', '商品入口关税(Import Duty)', 'getImportTariffsOnGoods', { decimal: 1, unit: 6, html:true, pla: '(自缴)' }),
      new ProfitInputBox('tax', '入口商品消费税(JCT)', 'getLocalConsumptionTax', { decimal: 1, unit: 6, pla: '(自缴)' }),
      new ProfitInputBox('tax', '商品入口综合税', 'getComprehensiveTaxesAndFeesOfTheImportingCountry', { decimal: 1, unit: 6 }),
    ])
    return obj
  }
  constructor(){}
}

export {
  BudgetProfitTest, ProfitInputBox, ProfitInputBoxModule,
  ProfitInputNewModule, INPUTENUM
}
